import { useEffect } from 'react';
import Lenis from '@studio-freight/lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function useLandingAnimations() {
	useEffect(() => {
		const lenis = new Lenis({
			duration: 1.1,
			smoothWheel: true,
			wheelMultiplier: 0.9,
		});

		const raf = (time) => {
			lenis.raf(time);
			requestAnimationFrame(raf);
		};
		const frame = requestAnimationFrame(raf);

		const revealItems = gsap.utils.toArray('[data-reveal]');
		revealItems.forEach((item) => {
			gsap.fromTo(
				item,
				{ autoAlpha: 0, y: 32 },
				{
					autoAlpha: 1,
					y: 0,
					duration: 0.8,
					ease: 'power3.out',
					scrollTrigger: {
						trigger: item,
						start: 'top 82%',
					},
				}
			);
		});

		gsap.to('[data-parallax="hero"]', {
			yPercent: 10,
			ease: 'none',
			scrollTrigger: {
				trigger: '.landing-hero',
				start: 'top top',
				end: 'bottom top',
				scrub: true,
			},
		});

		return () => {
			cancelAnimationFrame(frame);
			lenis.destroy();
			ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
		};
	}, []);
}
